import React from 'react'
import { SearchBox } from '../../../core/components/search-box/SearchBox'
import VisibleSearchFilters from '../containers/VisibleSearchFilters'
import { withExitableNav } from '../../../core/components/navbar/index'
import VisibleSearchResults from '../containers/VisibleSearchResults'
import './search.css'

const Search = ({ className }) => {
  const classNames = ['search', className]
  return (
    <div className={classNames.join(' ')}>
      <div className="gridcontainer">
        <div className="search__container">
          <div className="search__query">

            <VisibleSearchFilters />
          </div>
          <VisibleSearchResults />
        </div>
      </div>
    </div>
  )
}
export default withExitableNav(Search, '/', {CenterComponent: () => <SearchBox className='search__search-box' />})



// WEBPACK FOOTER //
// ./src/domains/search/components/Search.js